import BaseModel from './BaseModel';
import Reference from './Reference';
import ReviewMember from './ReviewMember';
import moment from 'moment';
import { validate } from 'uuid';

export default class ReviewerScreeningVote extends BaseModel {
  constructor(data = {}) {
    super(ReviewerScreeningVote, data);
    this.id = data.id;
    this.reviewer = data.reviewer
      ? new ReviewMember(data.reviewer)
      : null;
    this.reference = data.reference
      ? new Reference(data.reference)
      : null;
    this.vote = data.vote;
    this.createdAt = data.createdAt ? moment(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? moment(data.updatedAt) : null;
  }

  creationData() {
    const { id, vote } = this;
    return {
      id,
      vote,
      reviewer: validate(this.reviewer)
        ? this.reviewer
        : this.reviewer.id,
      reference: validate(this.reference)
        ? this.reference
        : this.reference.id,
    };
  }
}
